import { useRequest } from 'ahooks';
import {
  downLoadDocService,
  getAttachTypeListService,
  getMemoEventTypeService,
  getOrderDetailService,
  getOrderListService,
  orderProgressService,
  qryOrderStageService,
  saveFileService,
  appointmentModifyService,
  exportOrderListService,
} from './services';

import { getSystemParam } from '@/models/globalServices';
import { useState } from 'react';

export default function OrderMgrModal() {
  const [exportVisible, setExportVisible] = useState(false);
  const { runAsync: queryOrder } = useRequest(getOrderListService, {
    manual: true,
  });

  const { data: sysparamData, run: querySystemParam } = useRequest(
    getSystemParam,
    {
      manual: true,
    },
  );

  const { data: attachTypeList, run: queryAttachTypeList } = useRequest(
    getAttachTypeListService,
    {
      manual: true,
    },
  );

  const {
    loading: queryCustOrderLoading,
    data: custOrderDetail,
    run: queryOrderDetail,
  } = useRequest(getOrderDetailService, {
    manual: true,
  });

  const { run: downLoadDoc } = useRequest(downLoadDocService, {
    manual: true,
  });

  const { runAsync: saveFile } = useRequest(saveFileService, {
    manual: true,
  });

  const { data: memoEventTypeList, run: queryMemoEventTypeList } = useRequest(
    getMemoEventTypeService,
    {
      manual: true,
    },
  );
  const { data: orderProgressData, run: queryOrderProgress } = useRequest(
    orderProgressService,
    {
      manual: true,
    },
  );
  const { data: orderStageData, run: queryOrderStage } = useRequest(
    qryOrderStageService,
    {
      manual: true,
    },
  );
  const { loading: appointmentModifyLoading, runAsync: appointmentModify } = useRequest(
    appointmentModifyService,
    {
      manual: true,
    },
  );

  const { loading: exportOrderListLoading, runAsync: exportOrderList } =
  useRequest(exportOrderListService, {
    manual: true,
  });

  return {
    setExportVisible,
    exportVisible,
    saveFile,
    queryOrder,
    querySystemParam,
    queryAttachTypeList,
    queryOrderDetail,
    queryMemoEventTypeList,
    downLoadDoc,
    attachTypeList,
    memoEventTypeList,
    custOrderDetail,
    queryCustOrderLoading,
    sysparam: sysparamData || '6',
    orderProgressData,
    orderStageData,
    queryOrderProgress,
    queryOrderStage,
    appointmentModify,
    appointmentModifyLoading,
    exportOrderList,
    exportOrderListLoading,
  };
}
